import { mount } from "svelte";
import "../ui/tokens.css";
import App from "./App.svelte";

mount(App, { target: document.getElementById("root")! });
